import React from 'react';
import ImageInfo from '../controls/ImageInfo';
import { TabContextReporter } from '../TabContext';
export default function Image(props) {
  return /*#__PURE__*/React.createElement(TabContextReporter, {
    index: "0",
    title: "Image Information"
  }, /*#__PURE__*/React.createElement(ImageInfo, props));
}